import { Box, IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { String } from "../constants/Strings";
import { colors } from "../style/color/colors";
import { fonts } from "../style/fonts/fonts";
import { ImageLibrary } from "../constants/ImageLibrary";

export const PageTitle = ({
  PageTitle: title = String.journeyHeader.title,
  onBack,
  sx = {},
}) => {
  const navigation = useNavigate();
  return (
    <>
      <Box
        component="header"
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          width: "100%",
          zIndex: 1100,
          display: "flex",
          alignItems: "center",
          backgroundColor: colors.SecondaryMidnightBlue,
          py: "12px",
          px: "16px",
          minHeight: "64px",
          gap: "8px",
          boxSizing: "border-box",
          ...sx,
        }}
      >
        <IconButton
          sx={{ p: 0 }}
          onClick={onBack || (() => navigation(-1))}
          aria-label={String.journeyHeader.backLabel}
        >
          <Box
            component="img"
            src={ImageLibrary.BACK_ARROW_WHITE}
            alt=""
            aria-hidden="true"
            width="20px"
          />
        </IconButton>
        <Typography
          component="h1"
          sx={{
            color: colors.PrimaryWhite,
            fontSize: "16px",
            fontFamily: fonts.notoSans,
            fontWeight: 400,
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box sx={{ height: "64px", minHeight: "64px" }} aria-hidden="true" />
    </>
  );
};
